var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 26.25H26.25C24.8062 26.25 23.625 25.0688 23.625 23.625C23.625 22.1812 24.8062 21 26.25 21H34.125C34.125 21 42 12.2227 42 7.875C42 3.52734 38.4727 0 34.125 0C29.7773 0 26.25 3.52734 26.25 7.875C26.25 9.9668 28.0711 13.0758 29.966 15.75H26.25C21.9105 15.75 18.375 19.2855 18.375 23.625C18.375 27.9645 21.9105 31.5 26.25 31.5H34.125C35.5687 31.5 36.75 32.6813 36.75 34.125C36.75 35.5687 35.5687 36.75 34.125 36.75H15.2168C13.9043 38.7844 12.4441 40.6629 11.3367 42H34.125C38.4645 42 42 38.4645 42 34.125C42 29.7855 38.4645 26.25 34.125 26.25ZM34.125 5.25C35.577 5.25 36.75 6.42305 36.75 7.875C36.75 9.32695 35.577 10.5 34.125 10.5C32.673 10.5 31.5 9.32695 31.5 7.875C31.5 6.42305 32.673 5.25 34.125 5.25ZM7.875 21C3.52734 21 0 24.5273 0 28.875C0 33.2227 7.875 42 7.875 42C7.875 42 15.75 33.2227 15.75 28.875C15.75 24.5273 12.2227 21 7.875 21ZM7.875 31.5C6.42305 31.5 5.25 30.327 5.25 28.875C5.25 27.423 6.42305 26.25 7.875 26.25C9.32695 26.25 10.5 27.423 10.5 28.875C10.5 30.327 9.32695 31.5 7.875 31.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/line.2678b85d6dc3ff9c6e1bdd7bc7b4b76e.svg";